// extracted by mini-css-extract-plugin
export var actionButton = "TicketingSettingsPage-module__actionButton___WwspE";
export var backLink = "TicketingSettingsPage-module__backLink___-0SK-";
export var container = "TicketingSettingsPage-module__container___GZVGF";
export var emailInput = "TicketingSettingsPage-module__emailInput___P73JA";
export var emailLabel = "TicketingSettingsPage-module__emailLabel___NREFg";
export var emailRow = "TicketingSettingsPage-module__emailRow___Wb4Ux";
export var emailValue = "TicketingSettingsPage-module__emailValue___bhX7O";
export var errorMessage = "TicketingSettingsPage-module__errorMessage___rwzOW";
export var innerContainer = "TicketingSettingsPage-module__innerContainer___17mOM";
export var optOutCheckbox = "TicketingSettingsPage-module__optOutCheckbox___hH1zq";
export var optOutLabel = "TicketingSettingsPage-module__optOutLabel___PE81z";
export var optOutRow = "TicketingSettingsPage-module__optOutRow___6vKQA";
export var outerContainer = "TicketingSettingsPage-module__outerContainer___mbuKC";
export var pageTitle = "TicketingSettingsPage-module__pageTitle___mP6BQ";
export var section = "TicketingSettingsPage-module__section___V4PiF";
export var sectionTitle = "TicketingSettingsPage-module__sectionTitle___+Jgb9";
export var spinnerContainer = "TicketingSettingsPage-module__spinnerContainer___t0Kw-";
export var unverifiedBadge = "TicketingSettingsPage-module__unverifiedBadge___eYjyd";
export var verificationNotice = "TicketingSettingsPage-module__verificationNotice___9uWA9";
export var verifiedBadge = "TicketingSettingsPage-module__verifiedBadge___yHdgl";